export function botFlowEditor() {
    return {
        editorLoading: false,
        tabChanging: false,
        destroyed: false,
        modalScrollTop: 0,
        desktopTabs: false,
        desktopMediaQuery: null,
        desktopMediaHandler: null,
        scrollContainer: null,
        scrollHandler: null,
        cleanupMorph: null,
        cleanupTabCommit: null,
        requestedTab: null,
        rememberRequestedTab(event) {
            const tab = event.target.closest('[data-flow-editor-tabs] [data-flux-tab]');
            if (!tab || tab.getAttribute('aria-selected') === 'true') return;
            this.tabChanging = true;
            this.requestedTab = tab.getAttribute('name');
        },
        syncSelectedTab() {
            requestAnimationFrame(() => {
                if (this.destroyed || !this.requestedTab) return;
                if (this.requestedTab === this.$wire.editorTab) {
                    this.requestedTab = null;
                    return;
                }
                this.$wire.set('editorTab', this.requestedTab);
            });
        },
        init() {
            this.desktopMediaQuery = window.matchMedia('(min-width: 64rem)');
            this.desktopMediaHandler = () => {
                this.desktopTabs = this.desktopMediaQuery.matches;
            };
            this.desktopMediaHandler();
            this.desktopMediaQuery.addEventListener('change', this.desktopMediaHandler);
            this.scrollHandler = () => {
                this.modalScrollTop = this.scrollContainer?.scrollTop ?? 0;
            };
            this.bindScrollContainer();
            requestAnimationFrame(() => {
                if (!this.destroyed) this.bindScrollContainer();
            });
            this.cleanupMorph = Livewire.hook('morphed', ({ component }) => {
                if (component.el === this.$wire.$el) {
                    this.bindScrollContainer();
                    this.restoreModalScroll();

                    if (this.tabChanging) {
                        requestAnimationFrame(() => {
                            this.tabChanging = false;
                        });
                    }

                    this.syncSelectedTab();
                }
            });
            this.cleanupTabCommit = Livewire.hook('commit', ({ component, fail }) => {
                if (component.el !== this.$wire.$el) return;

                fail(() => {
                    this.tabChanging = false;
                });
            });
        },
        destroy() {
            this.destroyed = true;
            this.scrollContainer?.removeEventListener('scroll', this.scrollHandler);
            this.desktopMediaQuery?.removeEventListener('change', this.desktopMediaHandler);
            this.cleanupMorph?.();
            this.cleanupTabCommit?.();
        },
        bindScrollContainer() {
            const container = this.$el.querySelector('form [data-flow-editor-scroll][data-selected]');
            if (container === this.scrollContainer) return;

            this.scrollContainer?.removeEventListener('scroll', this.scrollHandler);
            this.scrollContainer = container;
            this.scrollContainer?.addEventListener('scroll', this.scrollHandler, { passive: true });
        },
        restoreModalScroll() {
            requestAnimationFrame(() => requestAnimationFrame(() => {
                if (this.destroyed) return;
                this.bindScrollContainer();
                const container = this.scrollContainer;
                if (container) {
                    container.scrollTop = Math.max(0, Math.min(this.modalScrollTop, container.scrollHeight - container.clientHeight));
                }
            }));
        },
    };
}

export function botApiVariablePicker() {
    return {
        variable: '',
        templateField: '',
        selectionStart: null,
        selectionEnd: null,
        inserted: false,
        insertedTimer: null,
        destroy() {
            clearTimeout(this.insertedTimer);
        },
        resetSelection() {
            this.selectionStart = this.selectionEnd = null;
        },
        rememberField(event) {
            const input = event.target;
            const name = input.closest('[data-api-template]')?.dataset.apiTemplate;
            if (!name || !input.matches('input, textarea')) return;
            this.templateField = name;
            this.selectionStart = input.selectionStart;
            this.selectionEnd = input.selectionEnd;
        },
        insertVariable() {
            if (!this.variable || !this.templateField) return;
            const name = this.templateField;
            const input = [...this.$el.querySelectorAll('[data-api-template]')]
                .find(field => field.dataset.apiTemplate === name)?.querySelector('input, textarea');
            if (!input) {
                this.templateField = '';
                this.resetSelection();
                return;
            }
            const text = String(this.$wire.get(name) ?? '');
            const start = Math.min(this.selectionStart ?? text.length, text.length);
            const end = Math.min(this.selectionEnd ?? start, text.length);
            const token = '{{ ' + this.variable + ' }}';
            this.$wire.set(name, text.slice(0, start) + token + text.slice(end), false);
            this.selectionStart = this.selectionEnd = start + token.length;
            this.variable = '';
            this.inserted = true;
            clearTimeout(this.insertedTimer);
            this.insertedTimer = setTimeout(() => { this.inserted = false; }, 2000);
            this.$nextTick(() => {
                input.focus({ preventScroll: true });
                input.setSelectionRange(this.selectionStart, this.selectionEnd);
            });
        },
    };
}
